import groq from 'groq';

export const PROMO_CODE = groq`
  promoCode -> {
    "code": code.current,
    discountClass,
    message,
  }
`;

export const PROMO_CODES = groq`
  promoCodes[]-> {
    "code": code.current,
    discountClass,
    message,
  }
`;

export const PROMO_CODE_BLOCK_OR_PARENT = groq`
  select(
    defined(${PROMO_CODES}) && count(${PROMO_CODES}) > 0 => ${PROMO_CODES},
    defined(^.promoCode->) => [^.${PROMO_CODE}],
    null
  )
`;
